var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#2b2f35","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-261 -76)"},React.createElement("g",null,React.createElement("path",{"fill":"#2b2f35","d":"M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10c0-2.652-1.054-5.196-2.929-7.071C15.196 1.054 12.652 0 10 0zm1 15H9V9h2v6zm0-8H9V5h2v2z","transform":"translate(261 76) translate(2 2)"})))));
}

IconInfo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
